export const iso3166 = [
    {
        value: "de",
        label: "Deutschland",
    },
    {
        value: "at",
        label: "Österreich",
    },
    {
        value: "ch",
        label: "Schweiz",
    },
    {
        value: "lu",
        label: "Luxemburg",
    },
    {
        value: "af",
        label: "Afghanistan",
    },
    {
        value: "eg",
        label: "Ägypten",
    },
    {
        value: "al",
        label: "Albanien",
    },
    {
        value: "dz",
        label: "Algerien",
    },
    {
        value: "ad",
        label: "Andorra",
    },
    {
        value: "ao",
        label: "Angola",
    },
    {
        value: "ai",
        label: "Anguilla",
    },
    {
        value: "aq",
        label: "Antarktis",
    },
    {
        value: "ag",
        label: "Antigua und Barbuda",
    },
    {
        value: "gq",
        label: "Äquatorial Guinea",
    },
    {
        value: "ar",
        label: "Argentinien",
    },
    {
        value: "am",
        label: "Armenien",
    },
    {
        value: "aw",
        label: "Aruba",
    },
    {
        value: "az",
        label: "Aserbaidschan",
    },
    {
        value: "et",
        label: "Äthiopien",
    },
    {
        value: "au",
        label: "Australien",
    },
    {
        value: "bs",
        label: "Bahamas",
    },
    {
        value: "bh",
        label: "Bahrain",
    },
    {
        value: "bd",
        label: "Bangladesh",
    },
    {
        value: "bb",
        label: "Barbados",
    },
    {
        value: "be",
        label: "Belgien",
    },
    {
        value: "bz",
        label: "Belize",
    },
    {
        value: "bj",
        label: "Benin",
    },
    {
        value: "bm",
        label: "Bermudas",
    },
    {
        value: "bt",
        label: "Bhutan",
    },
    {
        value: "mm",
        label: "Birma",
    },
    {
        value: "bo",
        label: "Bolivien",
    },
    {
        value: "ba",
        label: "Bosnien-Herzegowina",
    },
    {
        value: "bw",
        label: "Botswana",
    },
    {
        value: "bv",
        label: "Bouvet Inseln",
    },
    {
        value: "br",
        label: "Brasilien",
    },
    {
        value: "io",
        label: "Britisch-Indischer Ozean",
    },
    {
        value: "bn",
        label: "Brunei",
    },
    {
        value: "bg",
        label: "Bulgarien",
    },
    {
        value: "bf",
        label: "Burkina Faso",
    },
    {
        value: "bi",
        label: "Burundi",
    },
    {
        value: "cl",
        label: "Chile",
    },
    {
        value: "cn",
        label: "China",
    },
    {
        value: "cx",
        label: "Christmas Island",
    },
    {
        value: "ck",
        label: "Cook Inseln",
    },
    {
        value: "cr",
        label: "Costa Rica",
    },
    {
        value: "dk",
        label: "Dänemark",
    },
    {
        value: "dj",
        label: "Djibuti",
    },
    {
        value: "dm",
        label: "Dominika",
    },
    {
        value: "do",
        label: "Dominikanische Republik",
    },
    {
        value: "ec",
        label: "Ecuador",
    },
    {
        value: "sv",
        label: "El Salvador",
    },
    {
        value: "ci",
        label: "Elfenbeinküste",
    },
    {
        value: "er",
        label: "Eritrea",
    },
    {
        value: "ee",
        label: "Estland",
    },
    {
        value: "fk",
        label: "Falkland Inseln",
    },
    {
        value: "fo",
        label: "Färöer Inseln",
    },
    {
        value: "fj",
        label: "Fidschi",
    },
    {
        value: "fi",
        label: "Finnland",
    },
    {
        value: "fr",
        label: "Frankreich",
    },
    {
        value: "gf",
        label: "französisch Guyana",
    },
    {
        value: "pf",
        label: "Französisch Polynesien",
    },
    {
        value: "tf",
        label: "Französisches Süd-Territorium",
    },
    {
        value: "ga",
        label: "Gabun",
    },
    {
        value: "gm",
        label: "Gambia",
    },
    {
        value: "ge",
        label: "Georgien",
    },
    {
        value: "gh",
        label: "Ghana",
    },
    {
        value: "gi",
        label: "Gibraltar",
    },
    {
        value: "gd",
        label: "Grenada",
    },
    {
        value: "gr",
        label: "Griechenland",
    },
    {
        value: "gl",
        label: "GrÃ¶nland",
    },
    {
        value: "uk",
        label: "GroÃŸbritannien",
    },
    {
        value: "gb",
        label: "GroÃŸbritannien (UK)",
    },
    {
        value: "gp",
        label: "Guadeloupe",
    },
    {
        value: "gu",
        label: "Guam",
    },
    {
        value: "gt",
        label: "Guatemala",
    },
    {
        value: "gn",
        label: "Guinea",
    },
    {
        value: "gw",
        label: "Guinea Bissau",
    },
    {
        value: "gy",
        label: "Guyana",
    },
    {
        value: "ht",
        label: "Haiti",
    },
    {
        value: "hm",
        label: "Heard und McDonald Islands",
    },
    {
        value: "hn",
        label: "Honduras",
    },
    {
        value: "hk",
        label: "Hong Kong",
    },
    {
        value: "in",
        label: "Indien",
    },
    {
        value: "id",
        label: "Indonesien",
    },
    {
        value: "iq",
        label: "Irak",
    },
    {
        value: "ir",
        label: "Iran",
    },
    {
        value: "ie",
        label: "Irland",
    },
    {
        value: "is",
        label: "Island",
    },
    {
        value: "il",
        label: "Israel",
    },
    {
        value: "it",
        label: "Italien",
    },
    {
        value: "jm",
        label: "Jamaika",
    },
    {
        value: "jp",
        label: "Japan",
    },
    {
        value: "ye",
        label: "Jemen",
    },
    {
        value: "jo",
        label: "Jordanien",
    },
    {
        value: "yu",
        label: "Jugoslawien",
    },
    {
        value: "ky",
        label: "Kaiman Inseln",
    },
    {
        value: "kh",
        label: "Kambodscha",
    },
    {
        value: "cm",
        label: "Kamerun",
    },
    {
        value: "ca",
        label: "Kanada",
    },
    {
        value: "cv",
        label: "Kap Verde",
    },
    {
        value: "kz",
        label: "Kasachstan",
    },
    {
        value: "ke",
        label: "Kenia",
    },
    {
        value: "kg",
        label: "Kirgisistan",
    },
    {
        value: "ki",
        label: "Kiribati",
    },
    {
        value: "cc",
        label: "Kokosinseln",
    },
    {
        value: "co",
        label: "Kolumbien",
    },
    {
        value: "km",
        label: "Komoren",
    },
    {
        value: "cg",
        label: "Kongo",
    },
    {
        value: "cd",
        label: "Kongo, Demokratische Republik",
    },
    {
        value: "hr",
        label: "Kroatien",
    },
    {
        value: "cu",
        label: "Kuba",
    },
    {
        value: "kw",
        label: "Kuwait",
    },
    {
        value: "la",
        label: "Laos",
    },
    {
        value: "ls",
        label: "Lesotho",
    },
    {
        value: "lv",
        label: "Lettland",
    },
    {
        value: "lb",
        label: "Libanon",
    },
    {
        value: "lr",
        label: "Liberia",
    },
    {
        value: "ly",
        label: "Libyen",
    },
    {
        value: "li",
        label: "Liechtenstein",
    },
    {
        value: "lt",
        label: "Litauen",
    },
    {
        value: "mo",
        label: "Macao",
    },
    {
        value: "mg",
        label: "Madagaskar",
    },
    {
        value: "mw",
        label: "Malawi",
    },
    {
        value: "my",
        label: "Malaysia",
    },
    {
        value: "mv",
        label: "Malediven",
    },
    {
        value: "ml",
        label: "Mali",
    },
    {
        value: "mt",
        label: "Malta",
    },
    {
        value: "mp",
        label: "Marianen",
    },
    {
        value: "ma",
        label: "Marokko",
    },
    {
        value: "mh",
        label: "Marshall Inseln",
    },
    {
        value: "mq",
        label: "Martinique",
    },
    {
        value: "mr",
        label: "Mauretanien",
    },
    {
        value: "mu",
        label: "Mauritius",
    },
    {
        value: "yt",
        label: "Mayotte",
    },
    {
        value: "mk",
        label: "Mazedonien",
    },
    {
        value: "mx",
        label: "Mexiko",
    },
    {
        value: "fm",
        label: "Mikronesien",
    },
    {
        value: "mz",
        label: "Mocambique",
    },
    {
        value: "md",
        label: "Moldavien",
    },
    {
        value: "mc",
        label: "Monaco",
    },
    {
        value: "mn",
        label: "Mongolei",
    },
    {
        value: "ms",
        label: "Montserrat",
    },
    {
        value: "na",
        label: "Namibia",
    },
    {
        value: "nr",
        label: "Nauru",
    },
    {
        value: "np",
        label: "Nepal",
    },
    {
        value: "nc",
        label: "Neukaledonien",
    },
    {
        value: "nz",
        label: "Neuseeland",
    },
    {
        value: "ni",
        label: "Nicaragua",
    },
    {
        value: "nl",
        label: "Niederlande",
    },
    {
        value: "an",
        label: "Niederländische Antillen",
    },
    {
        value: "ne",
        label: "Niger",
    },
    {
        value: "ng",
        label: "Nigeria",
    },
    {
        value: "nu",
        label: "Niue",
    },
    {
        value: "kp",
        label: "Nord Korea",
    },
    {
        value: "nf",
        label: "Norfolk Inseln",
    },
    {
        value: "no",
        label: "Norwegen",
    },
    {
        value: "om",
        label: "Oman",
    },
    {
        value: "pk",
        label: "Pakistan",
    },
    {
        value: "ps",
        label: "Palästina",
    },
    {
        value: "pw",
        label: "Palau",
    },
    {
        value: "pa",
        label: "Panama",
    },
    {
        value: "pg",
        label: "Papua Neuguinea",
    },
    {
        value: "py",
        label: "Paraguay",
    },
    {
        value: "pe",
        label: "Peru",
    },
    {
        value: "ph",
        label: "Philippinen",
    },
    {
        value: "pn",
        label: "Pitcairn",
    },
    {
        value: "pl",
        label: "Polen",
    },
    {
        value: "pt",
        label: "Portugal",
    },
    {
        value: "pr",
        label: "Puerto Rico",
    },
    {
        value: "qa",
        label: "Qatar",
    },
    {
        value: "re",
        label: "Reunion",
    },
    {
        value: "rw",
        label: "Ruanda",
    },
    {
        value: "ro",
        label: "Rumänien",
    },
    {
        value: "ru",
        label: "Russland",
    },
    {
        value: "lc",
        label: "Saint Lucia",
    },
    {
        value: "zm",
        label: "Sambia",
    },
    {
        value: "as",
        label: "Samoa",
    },
    {
        value: "ws",
        label: "Samoa",
    },
    {
        value: "sm",
        label: "San Marino",
    },
    {
        value: "st",
        label: "Sao Tome",
    },
    {
        value: "sa",
        label: "Saudi Arabien",
    },
    {
        value: "se",
        label: "Schweden",
    },
    {
        value: "sn",
        label: "Senegal",
    },
    {
        value: "sc",
        label: "Seychellen",
    },
    {
        value: "sl",
        label: "Sierra Leone",
    },
    {
        value: "sg",
        label: "Singapur",
    },
    {
        value: "sk",
        label: "Slowakei -slowakische Republik-",
    },
    {
        value: "si",
        label: "Slowenien",
    },
    {
        value: "sb",
        label: "Solomon Inseln",
    },
    {
        value: "so",
        label: "Somalia",
    },
    {
        value: "gs",
        label: "South Georgia, South Sandwich Isl.",
    },
    {
        value: "es",
        label: "Spanien",
    },
    {
        value: "lk",
        label: "Sri Lanka",
    },
    {
        value: "sh",
        label: "St. Helena",
    },
    {
        value: "kn",
        label: "St. Kitts Nevis Anguilla",
    },
    {
        value: "pm",
        label: "St. Pierre und Miquelon",
    },
    {
        value: "vc",
        label: "St. Vincent",
    },
    {
        value: "kr",
        label: "Süd Korea",
    },
    {
        value: "za",
        label: "Südafrika",
    },
    {
        value: "sd",
        label: "Sudan",
    },
    {
        value: "sr",
        label: "Surinam",
    },
    {
        value: "sj",
        label: "Svalbard und Jan Mayen Islands",
    },
    {
        value: "sz",
        label: "Swasiland",
    },
    {
        value: "sy",
        label: "Syrien",
    },
    {
        value: "tj",
        label: "Tadschikistan",
    },
    {
        value: "tw",
        label: "Taiwan",
    },
    {
        value: "tz",
        label: "Tansania",
    },
    {
        value: "th",
        label: "Thailand",
    },
    {
        value: "tp",
        label: "Timor",
    },
    {
        value: "tg",
        label: "Togo",
    },
    {
        value: "tk",
        label: "Tokelau",
    },
    {
        value: "to",
        label: "Tonga",
    },
    {
        value: "tt",
        label: "Trinidad Tobago",
    },
    {
        value: "td",
        label: "Tschad",
    },
    {
        value: "cz",
        label: "Tschechische Republik",
    },
    {
        value: "tn",
        label: "Tunesien",
    },
    {
        value: "tr",
        label: "Türkei",
    },
    {
        value: "tm",
        label: "Turkmenistan",
    },
    {
        value: "tc",
        label: "Turks und Kaikos Inseln",
    },
    {
        value: "tv",
        label: "Tuvalu",
    },
    {
        value: "ug",
        label: "Uganda",
    },
    {
        value: "ua",
        label: "Ukraine",
    },
    {
        value: "hu",
        label: "Ungarn",
    },
    {
        value: "uy",
        label: "Uruguay",
    },
    {
        value: "uz",
        label: "Usbekistan",
    },
    {
        value: "vu",
        label: "Vanuatu",
    },
    {
        value: "va",
        label: "Vatikan",
    },
    {
        value: "ve",
        label: "Venezuela",
    },
    {
        value: "ae",
        label: "Vereinigte Arabische Emirate",
    },
    {
        value: "us",
        label: "Vereinigte Staaten von Amerika",
    },
    {
        value: "vn",
        label: "Vietnam",
    },
    {
        value: "vg",
        label: "Virgin Island (Brit.)",
    },
    {
        value: "vi",
        label: "Virgin Island (USA)",
    },
    {
        value: "wf",
        label: "Wallis et Futuna",
    },
    {
        value: "by",
        label: "Weissrussland",
    },
    {
        value: "eh",
        label: "Westsahara",
    },
    {
        value: "cf",
        label: "Zentralafrikanische Republik",
    },
    {
        value: "zw",
        label: "Zimbabwe",
    },
    {
        value: "cy",
        label: "Zypern",
    },
]